var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('h1',[_vm._v("Not Found")]),_vm._v(" "),_c('div',{staticClass:"contents__err"},[_c('span',[_vm._v(_vm._s(_vm.id))]),_vm._v(" "),_c('router-link',{staticClass:"btn-go-home",attrs:{"to":"/","tag":"button"}},[_vm._v("GO BACK TO HOME")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72276636","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/NotFound.vue
// module id = 368
// module chunks = 0